module.exports = __webpack_public_path__ + "images/7917619c469d7c3bb90b2a2a80bcfbe389b6280b8309304dd5939d8c90ed5fe1.svg";